export default __webpack_public_path__ + "static/media/headphones.218518c5.svg";